import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  styled,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Text = styled(Typography)({
  fontFamily: "'Red Hat Display'",
});

const InstructionsDialog = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: { sm: "60vw" }, // wider width
          height: { sm: "80vh" }, // taller height
          maxWidth: { sm: "900px" }, // optional: restrict max width
          ml: { sm: 20 },
        },
      }}
    >
      <DialogTitle sx={{ p: 1, textAlign: "center", fontWeight: 700, fontFamily: "'Red Hat Display'" }}>
        Guidelines
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ height: "100%" }}>
        <Text fontWeight="bold" gutterBottom sx={{ fontSize: "16px" }}>
          Instructions:
        </Text>

        <Text gutterBottom sx={{ fontSize: "14px" }}>
          You can generate accurate citation and metadata in multiple citation
          styles by entering one of the following identifiers:
        </Text>

        <Text fontWeight="bold" gutterBottom sx={{ fontSize: "16px", mt: 2 }}>
          Supported Input Types:
        </Text>

        <List sx={{ pl: 2, py: 0 }}>
          <ListItem disablePadding>
            <ListItemText
              primary={
                <Text sx={{ fontSize: "14px" }}>
                  • <strong>DOI</strong> (e.g., 10.1145/3368089.3409741,
                  https://doi.org/10.1145/3368089.3409741)
                </Text>
              }
            />
          </ListItem>

          <ListItem disablePadding>
            <ListItemText
              primary={
                <Text sx={{ fontSize: "14px" }}>
                  • <strong>ArXiv ID</strong> (e.g., {/* <strong> */}
                  arXiv:2106.01345, 2106.01345, https://arxiv.org/abs/2106.01345
                  )
                </Text>
              }
            />
          </ListItem>

          <ListItem disablePadding>
            <ListItemText
              primary={
                <Text sx={{ fontSize: "14px" }}>
                  • <strong>PubMed ID</strong> (e.g., PMID: 38413730, 8413730,
                  https://pubmed.ncbi.nlm.nih.gov/38413730/)
                </Text>
              }
            />
          </ListItem>

          <ListItem disablePadding>
            <ListItemText
              primary={
                <Text sx={{ fontSize: "14px" }}>
                  • <strong>Title</strong> (e.g., Attention Is All You Need)
                </Text>
              }
            />
          </ListItem>
        </List>

        <Text fontWeight="bold" gutterBottom sx={{ mt: 2, fontSize: "16px" }}>
          Tips for Best Results:
        </Text>

        <List sx={{ pl: 2, py: 0 }}>
          <ListItem disablePadding>
            <ListItemText
              primary={
                <Text sx={{ fontSize: "14px" }}>
                  • Only enter <strong>one</strong> type of input at a time.
                </Text>
              }
            />
          </ListItem>

          <ListItem disablePadding>
            <ListItemText
              primary={
                <Text sx={{ fontSize: "14px" }}>
                  • If pasting a full link (DOI, ArXiv, or PubMed), the system
                  will extract the necessary ID automatically.
                </Text>
              }
            />
          </ListItem>

          <ListItem disablePadding>
            <ListItemText
              primary={
                <Text sx={{ fontSize: "14px" }}>
                  • For <strong>titles</strong>, enter the full and correct
                  title to ensure accurate matching.
                </Text>
              }
            />
          </ListItem>
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default InstructionsDialog;
